<template>
  <div class="set-title">
    <el-dialog
      title="库存订单"
      :visible="true"
      @close="handleClose"
      width="860px"
    >
      <hx-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :height="360"
      >
        <!--商品数量-->
        <template slot="orderNumber" slot-scope="{ row }">
          <div class="">
            {{row.goodsSizeIn - (row.goodsSizeOut || 0) }}
          </div>
        </template>
      </hx-table>
      <div class="dialog-footer">
        <el-button class="search-btn btn-blue" @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "stock-order",
    props: {
      tableData: {
        type: Array,
        default: ()=>([])
      }
    },
    data(){
      return{
        tableColumn: [
          {
            label: '序号',
            width: 50,
            type: 'index'
          },
          {
            prop: 'orderId',
            label: '存放订单'
          },
          {
            prop: 'addTime',
            label: '存放时间'
          },
          {
            prop: 'addUserName',
            label: '存放人'
          },
          {
            prop: 'orderNumber',
            label: '商品数量(件)',
            slotName: 'orderNumber',
          },
        ],
      }
    },
    created() {
      this.tableData = this.tableData.filter(v=>{
        return v.goodsSizeIn - (v.goodsSizeOut || 0) > 0
      })
    },
    methods: {
      handleClose () {
        this.$options.cancel('cancel')
      }
    }
  }
</script>

<style scoped lang="less">
  .set-title {
    ::v-deep .el-dialog__header {
      text-align: center;
    }
    ::v-deep .el-dialog__body{
      padding-top: 10px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
    ::v-deep .el-input-number--medium {
      width: 100%;
    }
    ::v-deep .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
    }
    .w100{
      width: 100%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
    .w50{
      display: flex;
      width: 49%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
  }
</style>
